// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Restart = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <path d="M6.1,24.1c0-9.3,7.5-16.8,16.8-16.8s16.8,7.5,16.8,16.8-7.5,16.8-16.8,16.8" />
      <polyline points="14.5 18.5 6.1 24.1 .5 15.7" />
    </svg>
  );
};
